module.exports = __webpack_public_path__ + "static/media/user-block.511718fc.svg";